import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { addNotificationConfiguration, getALlRolesList, getGradList, getListNotificationConfiguration, getPositionList, getSingleNotifaiction, updateNotifiaction } from "./UseNotification"
import { toast } from "react-toastify"
import { showToast } from "../../utils/toastUtils"

interface NotificationInterface{
    start?: number,
    length?:number,
    search?:string
}

export const useGetNotificationList =({enable = false,params}:{enable:boolean,params:NotificationInterface})=>{
    return useQuery({
        queryKey:['GET_NOTIFICATION_LIST',params],
        queryFn:()=>getListNotificationConfiguration(params),
        retry:false,
        enabled:enable
    })
}

export const useGetSingleNotifiation=({enable= false,id}:{enable:boolean,id:number})=>{
    return useQuery({
        queryKey:['GET_SINGL_NOTIFICATON',id],
        queryFn:()=>getSingleNotifaiction(id),
        enabled: enable && !!id,
        retry:false,
    })
}


export const useGetRolesList = ({enable = false,params}:{enable:boolean,params:NotificationInterface})=>{
    return useQuery({
        queryKey:['GET_ROLES_LIST'],
        queryFn:()=>getALlRolesList(params),
        enabled:enable,
        retry:false,
        }) 
}

    interface ReqBody {
        Frequency?:number| null ,
        NotificationType: string,
        IsEnabled: number,
        Orgunitid:number | null,
        NotificationTime: string,
        NotificationDate:string | null,
        NotificationSubject: string,
        NotificationMessage:string,
        RedirectScreen: string,
        Grades: number[],
        Positions:number[]
}

export  const useAddNotificationConfiguration =()=>{
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn:({ReqBody}:{ReqBody:ReqBody})=>addNotificationConfiguration({ReqBody}),
        onSuccess:()=>{
            showToast.success('Add Notification successfully !')
            queryClient.invalidateQueries({ queryKey: ['GET_NOTIFICATION_LIST'] });
            queryClient.invalidateQueries({ queryKey: ['GET_SINGL_NOTIFICATON'] });

       
        },
        onError:(error:any)=>{
          console.log(`Failed to add Notification ${error.message}`);
          showToast.error(`Failed to add Notification`);
        }
    })
}

 
export const useUpdateNotification = ()=>{
    const queryClient = useQueryClient();
    return useMutation({
     mutationFn:({id,ReqBody}:{id:number,ReqBody:ReqBody})=>updateNotifiaction({id,ReqBody}),
     onSuccess:()=>{
        showToast.success('Update Notification Successfully ')
            queryClient.invalidateQueries({ queryKey: ['GET_NOTIFICATION_LIST'] });
            queryClient.invalidateQueries({ queryKey: ['GET_SINGL_NOTIFICATON'] });

    },
     onError:(error:any)=>{
        console.log(`Somethong went Wrong ${error.message}`);
        showToast.error('Failed to update Notifaction');
     }
    })
}

export const useGetGradeList = ({enable=false}:{enable:boolean})=>{
    return useQuery({
        queryKey:['GET_GRADE_LIST'],
        queryFn:getGradList,
        enabled:enable,
        retry:false
    })
}

export const useGetPositionList=({enable=false,params}:{enable:boolean,params:any})=>{
    return useQuery({
        queryKey:['GET_POSITION_LIST',params],
        queryFn:()=>getPositionList(params),
        enabled:enable,
        retry:false 
    })
}